import React from 'react';
const styles = require('./mini-loader.scss');

class MiniLoader extends React.Component<any, any> {
    render() {
        return (
            <div className={styles.box}>
                {/* <span>↓</span> */}
                <span>|</span>
                <span className={styles.d1}>|</span>
                <span className={styles.d2}>|</span>
                <span className={styles.d3}>|</span>
                <span className={styles.d4}>|</span>
            </div>
        )
    }
}
export default MiniLoader



// WEBPACK FOOTER //
// ./src/loaders/mini-loader.tsx